import { Component, Input } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'shop-favorite',
  templateUrl: 'shop-favorite.html',
})
export class ShopFavoriteComponent {
  //is_click: boolean = true;
  @Input() shop_data;

  constructor(
    public navCtrl: NavController,
    public apiProv: ApiProvider,
    public comProv: CommonProvider,
    public popoverCtrl: PopoverController,
  ) {
  }

  setFavorite() {
    if (!this.comProv.isLogin()) {
      this.comProv.alertLogin(this.navCtrl);
      return;
    }

    // 最大10件
    let shop_favorite_count = this.comProv.getOptionsValue('shop_favorite_count');

    let shop_favorite_limit = 5;
    let service_data = this.comProv.getService();
    if (service_data['option']['shop_favorite_limit'] != null) {
      shop_favorite_limit = service_data['option']['shop_favorite_limit'];
    }
    if (shop_favorite_count >= shop_favorite_limit) {
      this.comProv.dispAlert(shop_favorite_limit + '店舗までお気に入り登録が可能です。');
      return;
    }

    if (this.shop_data['is_click']) {
      return;
    }
    this.shop_data['is_click'] = true;
    
    this.apiProv.dispLoader();
    this.apiProv.post(this.shop_data['_links']['user_favorite_shop_store']['href'])
    .then(data => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      this.popFavorite();
      this.shop_data['is_favorite'] = true;
      this.comProv.setShopFavorite(this.shop_data['id'], true);
      this.comProv.setOptions('shop_favorite_count', shop_favorite_count + 1);

      // ホーム表示リセット
      this.comProv.setOptions('is_home_coupon_cache', 0);
      this.comProv.setOptions('is_home_event_cache', 0);
    }).catch(error => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  deleteFavorite() {
    if (!this.comProv.isLogin()) {
      this.comProv.alertLogin(this.navCtrl);
      return;
    }
    if (this.shop_data['is_click']) {
      return;
    }
    this.shop_data['is_click'] = true;
    
    this.apiProv.dispLoader();
    this.apiProv.delete(this.shop_data['_links']['user_favorite_shop_destroy']['href'])
    .then(data => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      //this.popFavorite(false);
      this.shop_data['is_favorite'] = false;
      this.comProv.setShopFavorite(this.shop_data['id'], false);

      let shop_favorite_count = this.comProv.getOptionsValue('shop_favorite_count');
      if (shop_favorite_count > 0) {
        this.comProv.setOptions('shop_favorite_count', shop_favorite_count - 1);
      }

      // ホーム表示リセット
      this.comProv.setOptions('is_home_coupon_cache', 0);
      this.comProv.setOptions('is_home_event_cache', 0);
    }).catch(error => {
      this.apiProv.removeLoader();
      this.shop_data['is_click'] = false;
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  popFavorite(is_set=true) {
    let popover = this.popoverCtrl.create('ShopSetPage',{is_set:is_set},{cssClass:'custom_popover',enableBackdropDismiss:false});
    popover.present();
  }
}


// WEBPACK FOOTER //
// ./src/components/shop-favorite/shop-favorite.ts